import { useQuery } from "@tanstack/react-query";
import { CompanyNewInterface } from "../../../../models/GeneralModule/CompanyNews";
import { CACHE_KEY_COMPANYNEWS } from "../../../../utils/constants";
import companyNewService from "../../../../services/general/companyNewService";

const useCompanyNews = () =>
  useQuery<CompanyNewInterface[], Error>({
    queryKey: [CACHE_KEY_COMPANYNEWS],
    queryFn: () => companyNewService.GetAll(),
  });

export default useCompanyNews;
